import React from "react"
import { Box } from "@mui/material"

//ads
import Ads from '../GoogleAdSense'

//ドロワ
const ArticleAdsComponent = (({ location }) => {

    const path = location ? location.pathname : "error: no path";

    return (
        <>
            {process.env.NODE_ENV === "development" ?
                <Box
                    sx={{
                        width: "100%",
                        backgroundColor: "gray",
                        height: "300px"
                    }}>
                    広告スペース
                </Box>
                :
                <Ads
                    path={path}
                    slot={process.env.GOOGLE_AD_SLOT1}
                    format={"auto"}

                />
            }
        </>
    )
})

export default ArticleAdsComponent